import React from 'react';
import './SponsorsSlider.css';

const SponsorsSlider = ({ sponsorLogos }) => {
  return (
    <div className="sponsorsContainer">
      <div className="sponsorsContent">
        {sponsorLogos.map((logo, index) => (
          <div key={index} className="logoContainer">
            <img src={logo} alt={`Sponsor ${index + 1}`} className="logo" />
          </div>
        ))}
        {/* Duplicate logos for seamless loop */}
        {sponsorLogos.map((logo, index) => (
          <div key={`clone-${index}`} className="logoContainer">
            <img src={logo} alt={`Sponsor ${index + 1}`} className="logo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SponsorsSlider; 